<template>
	<div>
		<ChangeController :visible='dataChanged' @close='show=false' @revert='revert' @save='save' />
		
		<v-card>
			<v-card-text>
				<section class="mb-10">
					<h2 class="mb-4">File Attachments</h2>
					<Collection
						cols='auto'
						:collection="data.files"
						@change="dataChanged = true"
						dialogWidth="600"
						:form="$options.FileForm"
						title="File Attachment"
						breakpoints="xs12 sm6 md6 lg4 xl3"
						isFileUpload
					>
						<FileItem slot-scope="{ item }" v-bind="item" />
					</Collection>
				</section>
				<section class='mt-10 mb-10'>
					<h2 class='mb-4'>About PRIMAR</h2>
					<TextEditor v-model='data.text' @show-change='dataChanged = true'  />
				</section>
				<section>
					<h2 class='mb-4'>Vision</h2>
					<TextEditor v-model='data.vision' @show-change='dataChanged = true'/>
				</section>
				<section class='mt-10 mb-10'>
					<h2 class='mb-4'>Guiding Principles</h2>
					<TextEditor v-model='data.guidelines' @show-change='dataChanged = true'/>
				</section>
				<section class='mb-10'>
					<h2 class='mb4'>Staff</h2>
      				<Collection 
					  cols='auto'
					  :collection='data.staff' 
					  @change="dataChanged = true" 
					  :form='$options.EmployeeForm' 
					  title='Employee' 
					  dialogWidth="500"
					  breakpoints="xs12 sm5 md3 lg2 xl3"
					  >
						<EmployeeItem slot-scope="{ item } " v-bind="item" />
      				</Collection>
				</section>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import TextEditor from '@/components/admin/TextEditor'

import Collection from '@/components/admin/ItemCollection'
import FileItem from '@/components/n-collections/n-items/FileItem'
import EmployeeItem from '@/components/n-collections/n-items/EmployeeItem'

import FileForm from '@/components/dialogs/forms/FileForm'
import EmployeeForm from '@/components/dialogs/forms/EmployeeForm'



import DataMixin from '@/mixins/DataMixin'

export default {
	name: 'AdminAbout',
	mixins: [DataMixin],
	FileForm,
	EmployeeForm,
	components: {
		TextEditor,
		Collection,
		FileItem,
		EmployeeItem,
	},
}
</script>

<style lang="scss" scoped>
</style>